import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsCustomerNotificationsAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-customer-notifications/src/helpCenterSettingsCustomerNotificationsAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { csmExperienceCustomerNotificationsRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceCustomerNotificationsRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';

const csmExperienceCustomerNotificationsPageEntryPoint = createPageEntryPoint({
	main,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
	},
});

export const csmExperienceCustomerNotificationsRouteEntry: Route = createEntry(
	csmExperienceCustomerNotificationsRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.csm-experience-customer-notifications',
		layout: serviceProjectLayout,
		navigation: {
			sidebarId: SidebarIdCsmApp,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? csmExperienceCustomerNotificationsPageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [...getCustomerServiceL1NavigationResources(), ...getCsmExperiencesResources()],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
